"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BooleanFilter = void 0;
var _simpleSearchQueryField = require("./simple-search-query-field");
class BooleanFilter extends _simpleSearchQueryField.SimpleSearchQueryField {
  constructor(searchOptions, withprice) {
    super(searchOptions, BooleanFilter.parse(withprice));
  }
  isDefault() {
    return !this.internalValue;
  }
  getUrlParameterValue() {
    return this.internalValue || null;
  }
  getCondensedValue() {
    return this.internalValue || null;
  }
  get value() {
    return this.internalValue || null;
  }
  static parse(value) {
    return value === true || typeof value === 'string' && value.toLowerCase() === 'true';
  }
}
exports.BooleanFilter = BooleanFilter;